module.exports = __webpack_public_path__ + "img/Toolbar_Left.a86bcfa9.svg";